import { GlobalVariables } from 'config/constant';
import { InputSize, InputTypes } from 'types/interfaces/Input.type';

export const loginFormConfig = {
  email: {
    label: 'auth.email',
    inputType: InputTypes.TEXT,
    fieldName: 'email',
    defaultValue: '',
    valueOptions: {
      minLength: GlobalVariables.Inputs.shortText.minLength,
      maxLength: GlobalVariables.Inputs.shortText.maxLength,
    },
    config: {
      required: 'auth.email_required',
      pattern: {
        value: GlobalVariables.REGEX.LoginFieldRegex,
        message: 'auth.email_invalid',
      },
      minLength: {
        value: GlobalVariables.Inputs.shortText.minLength,
        message: 'auth.email_too_short',
      },
      maxLength: {
        value: GlobalVariables.Inputs.shortText.maxLength,
        message: 'auth.email_too_long',
      },
    },
    size: InputSize.MEDIUM,
  },
  password: {
    label: 'auth.password',
    inputType: InputTypes.PASSWORD,
    fieldName: 'password',
    defaultValue: '',
    valueOptions: {
      minLength: GlobalVariables.Inputs.shortPassword.minLength,
    },
    config: {
      required: 'auth.password_required',
    },
    size: InputSize.MEDIUM,
    isPassword: true,
  },
};
